import {
    SofaType,
    SOFA_COLOUR_CHIP_PREFIX,
    COLOUR_CHIP_PREFIX,
    IMAGE_EXTENSION,
    SummaryType,
    BundleType,
} from "../../config/constants"

interface ColourChipUrlProps {
    type: SummaryType
    id: string
    imageCdnUrl: string
    colourChipImage?: string
}

interface ProductImageUrlProps {
    type: SummaryType
    imageCdnUrl: string
    productImageUrlPart: string
    lgImagePath?: string
    id: string
    mainImage?: string
    akamaiImageQueryParams: string
    im: string
    usePDPImage: boolean
}

export const getColourChipUrl = ({type, imageCdnUrl, id, colourChipImage}: ColourChipUrlProps): string => {
    return type === SofaType
        ? `${imageCdnUrl}/${SOFA_COLOUR_CHIP_PREFIX}/${colourChipImage}`
        : `${imageCdnUrl}/${COLOUR_CHIP_PREFIX}/${id}${IMAGE_EXTENSION}`
}

export const getProductImageUrl = ({
    type,
    imageCdnUrl,
    productImageUrlPart,
    lgImagePath,
    id,
    mainImage,
    akamaiImageQueryParams,
    im,
    usePDPImage,
}: ProductImageUrlProps): string => {
    const suffixedId = usePDPImage ? `${id}s` : id
    let queryString = akamaiImageQueryParams ? `?im=${akamaiImageQueryParams}` : ""
    queryString = im ? `?im=${im}` : queryString

    // New logic for BundleType
    if (type === BundleType) {
        // Replace the first '/' and everything after it with '/bundle'
        const modifiedUrlPart = productImageUrlPart.replace(/\/.*$/, "/Bundle")
        const completeUrl = `${imageCdnUrl}/${modifiedUrlPart}/${lgImagePath}/${suffixedId}${IMAGE_EXTENSION}${queryString}`
        return completeUrl
    }

    // SofaType Logic
    return type === SofaType
        ? `${imageCdnUrl}/${productImageUrlPart}/${lgImagePath}/${mainImage}${queryString}`
        : `${imageCdnUrl}/${productImageUrlPart}/${lgImagePath}/${suffixedId}${IMAGE_EXTENSION}${queryString}`
}
